module.exports = __webpack_public_path__ + "static/media/c-live.dfd5fc15.png";